import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgBlocker = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M2 10.747q0 1.242.384 2.215a4.6 4.6 0 0 0 1.076 1.646 4.6 4.6 0 0 0 1.634 1.033 5.8 5.8 0 0 0 2.07.359q1.792 0 2.959-.748 1.167-.75 1.905-2.245.217-.42.414-.876t.376-.95q.18-.502.354-1.04a164 164 0 0 0 .557-1.774q.113-.353.188-.651.083-.3.083-.48a.63.63 0 0 0-.203-.486.72.72 0 0 0-.52-.187.84.84 0 0 0-.602.24q-.24.24-.504.77L11.124 9.76a.66.66 0 0 1-.165.254.3.3 0 0 1-.181.075.27.27 0 0 1-.196-.075q-.068-.082-.068-.277v-7.85a.75.75 0 0 0-.24-.561.76.76 0 0 0-.565-.24q-.331 0-.572.24a.76.76 0 0 0-.234.56V7.5a3.5 3.5 0 0 0-.67-.18V.809a.76.76 0 0 0-.24-.57A.76.76 0 0 0 7.427 0q-.34 0-.58.24a.77.77 0 0 0-.233.568v6.429a10 10 0 0 0-.708.09V1.443a.75.75 0 0 0-.24-.56.76.76 0 0 0-.565-.24q-.332 0-.573.24a.76.76 0 0 0-.233.56v6.391q-.188.09-.361.187-.165.098-.316.195V3.772a.75.75 0 0 0-.241-.562.76.76 0 0 0-.565-.239q-.339 0-.58.24A.76.76 0 0 0 2 3.77z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBlocker);
export default ForwardRef;
